import { Component, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, MessageType, UpdateStatusType } from '../../../models/enums';
import { ExportStream } from '../../../models/export-stream';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';

@Component({
    standalone: false,
    selector: 'res-export-duplicates-volume-modal',
    templateUrl: './export-duplicates-volume-modal.component.html',
    styleUrls: ['./export-duplicates-volume-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ExportDuplicatesVolumeModalComponent extends BaseModalComponent {
    modalTitle = 'Export Duplicates Volume';
    automationId = 'export-duplicates-volume-modal';
    isBusy = false;
    isBusyMessage = 'Loading...';
    modalHelpIndex = HelpIndex.exports_stream_export_dupes_vol_dlg;
    modalClass = 'export-duplicates-volume';

    exportStream: ExportStream;
    produceDuplicateFiles = true;

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
        if (this.modalData && this.modalData.exportStream instanceof ExportStream) {
            this.exportStream = this.modalData.exportStream;
        }
    }

    okEnabled = (): boolean => {
        return !this.isBusy && Boolean(this.exportStream);
    }

    ok = (): void => {
        this.isBusy = true;
        this.restService.post(Endpoint.groupViewManager_produceDuplicatesVolume, {
            produceDuplicateFiles: this.produceDuplicateFiles,
            exportStreamHandle: this.exportStream.handle,
            taskDescription: `Creating duplicates volume for ${this.exportStream.name}`
        }).then(response => {
            this.isBusy = false;
            this.commonService.sendMessage(MessageType.entityChanged, UpdateStatusType.EXPORT_VIEW);
        }, error => {
            this.isBusy = false;
        });
        this.closeModal();
    }
}
